import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { initializeAuth } from "../utils/authInitializer";

/**
 * Hook to initialize authentication state on app startup
 * This should be called once when the app starts
 */
export const useAuthInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize authentication state from localStorage
    initializeAuth(dispatch);
  }, [dispatch]);
};
